// import React from 'react';

const Quote = () => (
  <div className="big-container">
    <div className="quote-container">
      <span>
        Mathematics is not about numbers, equations, computations,
        or algorithms: it is about understanding.
        <hr />
        <strong>- William Paul Thurston</strong>
      </span>
    </div>
  </div>
);

export default Quote;
